export const isEventWithinElement = (event: Pick<Event, "composedPath">, element: EventTarget | null): boolean =>
  element !== null && event.composedPath().includes(element)
